/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import React from 'react';
import { DISPLAY_FAMILY_PLANNING_TABLEHEAD } from '../../../../utility/tableHeads';
import DisplayFamilyTableComponent from './DisplayFamilyTableComponent';
import cancelIcon from '../../../../../../../assets/images/Icon-cancel.png';
import { PaperComponent } from '../../../../../../../SharedModules/utilities/utilities';

const DisplayFamilyPlanning = ({
  open = false,
  data = [],
  handleClose = () => {},
}) => {
  return (
    <Dialog
      open={open}
      className="inbuilt-dialog custom-dialog-box dialogPanel multiGroupDialog"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle
        className="copy-contact-title"
        style={{ cursor: 'move' }}
        id="draggable-dialog-title"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="dialog-heading-txt">
            Display Family Planning Drugs
          </div>
          <div className="close-popup-icon" role="button" onClick={handleClose}>
            <img alt="" src={cancelIcon} />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DisplayFamilyTableComponent
          tableData={data}
          tableHead={DISPLAY_FAMILY_PLANNING_TABLEHEAD}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DisplayFamilyPlanning;
